import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EyeIcon } from '@heroicons/react/24/outline';

import { Tooltip } from '~/components/Tooltip';

export const ReadOnlyBadge: FC = () => {
  const { t } = useTranslation();
  const label = t('community.space.read_only_tooltip');

  return (
    <Tooltip content={<span className="block max-w-[240px]">{label}</span>} placement="bottom-end" interactive>
      <button
        type="button"
        aria-label={label}
        className="inline-flex size-7 cursor-help items-center justify-center rounded-full border border-black/10 bg-black/[0.04] text-black/50"
      >
        <EyeIcon aria-hidden="true" className="size-3.5 shrink-0" />
      </button>
    </Tooltip>
  );
};
